import { DocumentSearchPanel } from "@components/panels/DocumentSearchPanel"

import { facets } from "@constants/facets"

import { DocumentSearchProvider } from "@plugins/providers/document/DocumentSearchProvider"

export function AdvancedSearchPage() {
    return (
        <DocumentSearchProvider facets={facets}>
            <DocumentSearchPanel />
        </DocumentSearchProvider>
    )
}
